/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeDechetDto } from '../models/type-dechet-dto';


/**
 * Fonctions de gestion des types de déchets
 */
@Injectable({
  providedIn: 'root',
})
export class TypesDechetsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeDechetGetList
   */
  static readonly TypeDechetGetListPath = '/api/types-dechets/list';

  /**
   * Renvoie la liste des types de déchets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeDechetDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsService.TypeDechetGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeDechetDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types de déchets.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetGetList(params?: {
  }): Observable<Array<TypeDechetDto>> {

    return this.typeDechetGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeDechetDto>>) => r.body as Array<TypeDechetDto>)
    );
  }

  /**
   * Path part for operation typeDechetLoadList
   */
  static readonly TypeDechetLoadListPath = '/api/types-dechets/load-list';

  /**
   * Renvoie la liste des types de déchets (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsService.TypeDechetLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types de déchets (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeDechetLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeDechetGet
   */
  static readonly TypeDechetGetPath = '/api/types-dechets/{id}';

  /**
   * Renvoie le type de déchets spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetGet$Response(params: {

    /**
     * Identifiant du type de déchets
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeDechetDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsService.TypeDechetGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetDto>;
      })
    );
  }

  /**
   * Renvoie le type de déchets spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetGet(params: {

    /**
     * Identifiant du type de déchets
     */
    id: number;
  }): Observable<TypeDechetDto> {

    return this.typeDechetGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetDto>) => r.body as TypeDechetDto)
    );
  }

  /**
   * Path part for operation typeDechetPut
   */
  static readonly TypeDechetPutPath = '/api/types-dechets/{id}';

  /**
   * Modifie le type de déchets spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetPut$Response(params: {

    /**
     * Identifiant du type de déchets
     */
    id: number;

    /**
     * Les valeurs du type de déchets
     */
    body: TypeDechetDto
  }): Observable<StrictHttpResponse<TypeDechetDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsService.TypeDechetPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetDto>;
      })
    );
  }

  /**
   * Modifie le type de déchets spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetPut(params: {

    /**
     * Identifiant du type de déchets
     */
    id: number;

    /**
     * Les valeurs du type de déchets
     */
    body: TypeDechetDto
  }): Observable<TypeDechetDto> {

    return this.typeDechetPut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetDto>) => r.body as TypeDechetDto)
    );
  }

  /**
   * Path part for operation typeDechetDelete
   */
  static readonly TypeDechetDeletePath = '/api/types-dechets/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsService.TypeDechetDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.typeDechetDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation typeDechetDesactivate
   */
  static readonly TypeDechetDesactivatePath = '/api/types-dechets/{id}/desactivate';

  /**
   * Désactive le type de déchets spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetDesactivate$Response(params: {

    /**
     * Identifiant du type de déchets à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeDechetDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsService.TypeDechetDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le type de déchets spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetDesactivate(params: {

    /**
     * Identifiant du type de déchets à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeDechetDto
  }): Observable<number> {

    return this.typeDechetDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeDechetGetByReference
   */
  static readonly TypeDechetGetByReferencePath = '/api/types-dechets/reference/{reference}';

  /**
   * Renvoie le type de déchets recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<TypeDechetDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsService.TypeDechetGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetDto>;
      })
    );
  }

  /**
   * Renvoie le type de déchets recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<TypeDechetDto> {

    return this.typeDechetGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetDto>) => r.body as TypeDechetDto)
    );
  }

  /**
   * Path part for operation typeDechetSetToAllActiveParcs
   */
  static readonly TypeDechetSetToAllActiveParcsPath = '/api/types-dechets/{id}/setToAllActiveParcs';

  /**
   * Associe le type de déchets spécifié à tous les parcs actifs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetSetToAllActiveParcs()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetSetToAllActiveParcs$Response(params: {

    /**
     * Identifiant du type de déchets
     */
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsService.TypeDechetSetToAllActiveParcsPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Associe le type de déchets spécifié à tous les parcs actifs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetSetToAllActiveParcs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetSetToAllActiveParcs(params: {

    /**
     * Identifiant du type de déchets
     */
    id: number;
  }): Observable<Blob> {

    return this.typeDechetSetToAllActiveParcs$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
